module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"other":"Standard","title":"Behandlingsregel"},"en":{"other":"Default","title":"Treatmentrule"}}')
  delete Component.options._Ctor
}
